import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import api from "../../../helper/api";
import { toast } from "react-toastify";

export const getAdminCommission = createAsyncThunk("user/getAdminCommission", async (payload) => {

  const response = await api.get("admin/commission/admin-wise-commission", payload);
 
  return response.data;
});

const getAdminCommissionSlice = createSlice({
  name: "user",
  initialState: {
    data:null,
    loading: false,
    error: null,
  },
  middleware: (getDefaultMiddleware) =>
  getDefaultMiddleware({
    serializableCheck: {
      ignoredPaths: ["payload.headers"],
    },
  }),
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAdminCommission.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAdminCommission.fulfilled, (state, action) => {
   
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getAdminCommission.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        toast.error(action.error.message);
      });
  },
});

export default getAdminCommissionSlice.reducer;
